module.exports = __webpack_public_path__ + "img/05-dark.de19bd35.png";